import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { CurrentUserFragment } from "@/generated/graphql/graphql";
import { localOrSecureStorage } from "@/stores/localOrSecureStorage";

type AuthStatus = "LOGGED_OUT" | "LOGGED_IN";

type AuthData = {
  currentUser: CurrentUserFragment | undefined;
  authStatus: AuthStatus;
};

type AuthAction = {
  setCurrentUser: (user: AuthData["currentUser"]) => void;
  authStatus: AuthStatus;
  clear: () => void;
};

type AuthState = AuthData & AuthAction;

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      authStatus: "LOGGED_OUT",
      clear: () => set({ authStatus: "LOGGED_OUT", currentUser: undefined }),
      currentUser: undefined,
      setCurrentUser: (user) => set({ authStatus: "LOGGED_IN", currentUser: user }),
    }),
    {
      name: "auth-store",
      partialize: (state): AuthData => ({ authStatus: state.authStatus, currentUser: state.currentUser }),
      storage: createJSONStorage(() => localOrSecureStorage),
    },
  ),
);
